module.exports = __webpack_public_path__ + "db13d88a57bdb6e4ee6317b40163387a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/games/Dawn-of-War-II.jpg
// module id = 248
// module chunks = 0